var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('v-row',[_c('v-col',[(_vm.data.status==null)?_c('Order'):_vm._e(),(_vm.data.status!=null)?_c('Orderpayment'):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }